import React from 'react'
import { WhatsAppOption } from './Options/WhatsAppOption'
import { EmailOption } from './Options/EmailOption'
import { PhoneOption } from './Options/PhoneOption'

export const OptionsSelect = ({ optionSelected }) => {
  const opts = {
    EMAIL: <EmailOption />,
    WHATSAPP: <WhatsAppOption />,
    TELEFONE: <PhoneOption />,
  }

  return opts[optionSelected] || null
}
